import { render, staticRenderFns } from "./StreamingTab.vue?vue&type=template&id=f1cdedb2&scoped=true&"
import script from "./StreamingTab.vue?vue&type=script&lang=js&"
export * from "./StreamingTab.vue?vue&type=script&lang=js&"
import style0 from "./StreamingTab.vue?vue&type=style&index=0&id=f1cdedb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cdedb2",
  null
  
)

export default component.exports